import { render, staticRenderFns } from "./AtomAvatarSecondary.vue?vue&type=template&id=315562c7&"
import script from "./AtomAvatarSecondary.vue?vue&type=script&lang=js&"
export * from "./AtomAvatarSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports